import React from "react";
import ComingSoonPanel from "../components/ComingSoonPanel";

const ProductPLPage: React.FC = () => {
    return (
        <ComingSoonPanel
            title="商品累計損益"
            description="期間累計のPL、在庫評価を商品単位で表示する想定です。"
        />
    );
};

export default ProductPLPage;
